import { useContext } from 'react'
import { MosContext } from './MosInfoProvider'

const useMosInfo = () => {
  return useContext(MosContext)
}

export default useMosInfo
